import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";

export class DbProdfieldApi extends DbCenterBaseApi {

    public get ControllerName(): any {
        return 'dbProdfield';
    }

    /**
     * 获取表字段
     * @param tableId 
     * @returns 
     */
    public getDbFieldByTableId(tableId) {
        return this.send({ tableId }, 'getDbFieldByTableId', Methods.GET);
    }

    /**
     * 根据Gray字段获取Prod字段
     * @param grayFieldId 
     * @returns 
     */
    public getDbFieldByGrayFieldId(grayFieldId) {
        return this.send({ grayFieldId }, 'getDbFieldByGrayFieldId', Methods.GET);
    }

}